import { createReducer } from '@reduxjs/toolkit';
import type { Draft } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';
import type { Action } from 'redux';

import { UPDATE_VENDOR_SUBLET_SUCCESS, LOAD_VENDOR_SUBLETS_SUCCESS } from './actions';
import type { VendorSublet } from './types';

interface State {
  entities: {
    [id: string]: VendorSublet;
  };
}

export const initialState: State = {
  entities: {},
};

type LoadVendorSubletsSuccessAction = Action<typeof LOAD_VENDOR_SUBLETS_SUCCESS> & {
  vendorSublets: VendorSublet[];
};
type UpdateVendorSubletSuccessAction = Action<typeof UPDATE_VENDOR_SUBLET_SUCCESS> & {
  vendorSublet: VendorSublet;
};

const loadVendorSubletsSuccess = (
  state: Draft<State>,
  action: LoadVendorSubletsSuccessAction
) => {
  state.entities = { ...state.entities, ..._.keyBy(action.vendorSublets, 'id') };
};

const updateVendorSubletSuccess = (
  state: Draft<State>,
  action: UpdateVendorSubletSuccessAction
) => {
  state.entities = { ...state.entities, [action.vendorSublet.id]: action.vendorSublet };
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(LOAD_VENDOR_SUBLETS_SUCCESS, loadVendorSubletsSuccess);
  builder.addCase(UPDATE_VENDOR_SUBLET_SUCCESS, updateVendorSubletSuccess);
});
